import React from 'react';
import PropTypes from 'prop-types';
import {viewWrapper} from '../../viewWrapper';
import {BrowserRouter} from 'react-router-dom';
import tropic from '../../tropic';
import NavBar from '../../components/common/NavBar';
import Footer from '../../components/common/Footer';
import SimpleField from '@/js/components/common/SimpleField';
import { genericOnChangeCreator } from '@/js/formHelpers';
import { required} from '../../validators';
import { clone } from '@/js/util';


class ResetPassword extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.onSubmit = this.onSubmit.bind(this);

		this.state = {
			values: { compassID: ''},
			meta: { compassID: { touched: true, errorMessage: ''} },
			formSubmissionSuccessful: false
		};

	}

	validateCompassID(val) {
		return required(val, 'Compass ID');
	}

	onSubmit(e) {
		e.preventDefault();

		let error = this.validateCompassID(this.state.values.compassID);
		if(error) {
			this.setState(prevState => {
				let newState = clone(prevState);
				newState.meta.compassID = { errorMessage: error, touched:true };
				return newState;
			});
		} else {
			tropic.fetch({
				url: `/api/resetPassword`,
				method: 'POST',
				body: JSON.stringify({'compassID': this.state.values.compassID})
			}).then((result) => {
				this.setState({
					formSubmissionSuccessful: true
				});
			}).catch((error) => {
				this.setState({
					formSubmissionSuccessful: false
				});
			});
		}
	}

	drawForm() {
		return(
			<form onSubmit={this.onSubmit}>
				<div className='form-group'>
					<p>Enter your Compass ID and we'll send an email to the address on file for your account.</p>
					<SimpleField name="compassID"
						id="compassID"
						label="Compass ID"
						type="text"
						maxLength={20}
						value={this.state.values.compassID}
						touched={this.state.meta.compassID.touched}
						errorMessage={this.state.meta.compassID.errorMessage}
						onChange={genericOnChangeCreator(this, 'compassID', this.validateCompassID)}
						onBlur={genericOnChangeCreator(this, 'compassID', this.validateCompassID)}
						validationIconClass="validationErrorIcon"
					/>
				</div>
				<div className='d-flex justify-content-between align-items-center'>
					<a href='/Login' className='pe-3'>Back to login</a>
					<input className='btn btn-primary btn-lg' type='submit' value='Reset Password' />
				</div>
			</form>
		);
	}

	drawSuccess() {
		return (
			<div>
				<p>If we found your Compass ID in our in system, we sent an email to the address on file with instructions to reset your password.</p>
				<p>If you don't get an email, check your spam folder or contact your onPeak administrator for assistance.</p>
			</div>
		);
	}

	render() {
		const baseUrl = 'ResetPassword';

		let pageContent = (
			<div>
				<h2>Reset Password</h2>
				<div className='ResetPasswordCard card mb-3'>
					<div className='card-body'>
						{this.state.formSubmissionSuccessful ? this.drawSuccess() : this.drawForm()}
					</div>
				</div>
			</div>
		);


		if (this.props.appState.cognitoEnabled === 'Y') {
			pageContent = (
				<h2 className="text-center mb-3">User must use their Single Sign-On Provider to reset their password</h2>
			);
		}

		return (
			<BrowserRouter basename={baseUrl}>
				<div className='ResetPasswordView'>
					<NavBar loggedIn = {false} />
					<div className='container-fluid'>
						<div className='ResetPasswordForm col-12 col-sm-8 col-md-6 col-lg-4 mx-auto'>
							{pageContent}
							{Footer}
						</div>
					</div>
				</div>
			</BrowserRouter>
		);
	}
}

ResetPassword.propTypes = {
	// default view props
	appState: PropTypes.object.isRequired,
	loading: PropTypes.object,
	viewData: PropTypes.object
};

let ResetPasswordView = viewWrapper({
	enableIntercom: false
})(ResetPassword);


/* gives wrapped view component as an argument to a function
that does React.render(<App><View/></App>, MOUNT_NODE);*/

tropic.bootstrapView(ResetPasswordView);
